import type { InteractionHistory } from 'types/entity'
import { formatShortDateTime } from 'utils/dotNetDate'

const AVATAR_FALLBACK =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><rect width="48" height="48" fill="#e5f6ec"/><circle cx="24" cy="18" r="8" fill="#bfd4c8"/><path d="M6 47c2-10 9-15 18-15s16 5 18 15z" fill="#bfd4c8"/></svg>`,
  )

/**
 * Port of `CreateFollowUpView` + `GetFollowUpData`.
 *
 * The legacy loop rendered the contact header from the first row only, then one
 * block per interaction; that structure is kept.
 */
export function FollowUpDetailView({ interactions }: { interactions: InteractionHistory[] }) {
  if (interactions.length === 0) {
    return (
      <div className="entity-main">
        <h5>Followup Details</h5>
        <div className="empty-state">No Record Found</div>
      </div>
    )
  }

  const [first] = interactions
  const mobiles = [first.MobileNo, first.MobileNo1, first.MobileNo2].filter(Boolean).join(', ')

  return (
    <div className="entity-main">
      <h5>Followup Details</h5>

      <div className="details-header">
        <img
          className="related-avatar"
          src={first.ProfileImgFileName || AVATAR_FALLBACK}
          alt={first.PersonName}
          onError={(e) => {
            e.currentTarget.src = AVATAR_FALLBACK
          }}
        />
        <div>
          <h4 className="lead-title">
            <span className="k">Related To:</span> {first.PersonName}
          </h4>
          <div className="font13">
            <span className="mr-2">
              <span className="k">Mobile No.:</span> {mobiles || '—'}
            </span>
            <span>
              <span className="k">Lead No.:</span> {first.LeadNo}
            </span>
          </div>
        </div>
      </div>

      {interactions.map((interaction, i) => (
        <div className="lead-content" key={`${interaction.CreatedOn}-${i}`}>
          <h3>{interaction.FollowupStatus}</h3>
          {interaction.Remarks && <p>{interaction.Remarks}</p>}

          <div className="detail-grid">
            <Detail label="Created Date" value={formatShortDateTime(interaction.CreatedOn)} />
            <Detail label="Due Date" value={formatShortDateTime(interaction.NextStatusDate)} />
            <Detail label="Amount" value={interaction.AmountPaid} />
            <Detail label="Assign To" value={interaction.AssignedTo} />
            <Detail label="Created By" value={interaction.CreatedBy} />
            <Detail label="Product" value={interaction.Products} />
          </div>
        </div>
      ))}
    </div>
  )
}

function Detail({ label, value }: { label: string; value: string }) {
  if (!value) return null
  return (
    <div className="detail-item">
      <span className="k">{label}:</span>
      <span>{value}</span>
    </div>
  )
}
